/**
 * "The sign-in has expired" — raised by any tool that gets a 401, shown once by
 * the app shell as a banner with a sign-out button.
 *
 * A module store rather than state in App.tsx, so a tool reports it without the
 * shell threading a callback into every page.
 */

let expired = false
const listeners = new Set<() => void>()

function emit() {
    for (const listener of listeners) listener()
}

export function subscribeSession(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}

export function isSessionExpired(): boolean {
    return expired
}

export function reportSessionExpired() {
    if (expired) return
    expired = true
    emit()
}

export function clearSessionExpired() {
    if (!expired) return
    expired = false
    emit()
}
